import React, { createContext, useContext, useMemo, useState } from "react";
import pl from "../locales/pl.json";
import en from "../locales/en.json";
import de from "../locales/de.json";
import es from "../locales/es.json";
import uk from "../locales/uk.json";

// Tresc produktow (ebooki/audiobooki/opisy aplikacji) pozostaje po polsku - ten przelacznik tlumaczy
// na razie interfejs strony (nawigacja, stopka), zeby byl realnie uzyteczny dla obcokrajowcow
// mieszkajacych w Polsce od razu, a nie dopiero po przetlumaczeniu calej tresci katalogu.
export const LANGUAGES = [
  { code: "pl", label: "Polski", flag: "🇵🇱" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "uk", label: "Українська", flag: "🇺🇦" },
];

const DICTS = { pl, en, de, es, uk };
const LanguageContext = createContext(null);

function detectDefault() {
  try {
    const saved = localStorage.getItem("dl_lang");
    if (saved && DICTS[saved]) return saved;
  } catch { /* localStorage niedostepny */ }
  return "pl";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectDefault);

  const setLang = (code) => {
    if (!DICTS[code]) return;
    setLangState(code);
    try { localStorage.setItem("dl_lang", code); } catch { /* localStorage niedostepny */ }
  };

  const t = useMemo(() => {
    const dict = DICTS[lang] || DICTS.pl;
    return (key) => dict[key] ?? DICTS.pl[key] ?? key;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage musi byc uzyte wewnatrz LanguageProvider");
  return ctx;
}
